import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NoShowCommentComponent } from '@sc/ui-components';

@Component({
  selector: 'sc-no-show-comment-dialog',
  styleUrls: ['./no-show-comment-dialog.component.scss'],
  imports: [NoShowCommentComponent],
  template: `<sc-no-show-comment
    (actionClick)="noShowCommentAction($event)"
  ></sc-no-show-comment>`,
})
export class NoShowCommentDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<NoShowCommentDialogComponent>
  ) {}

  noShowCommentAction($event) {
    this.dialogRef.close($event);
  }
}
